export const Colors = {
    background: '#ededed',
    card: 'white',
    primary: 'rgb(110,61,50)',
    primaryDarker: '#4f2b23',
    font: 'black',
    green: '#8cbb6c'
  }

export const Sizes = {
  pageMaxWidth: 1000
}